import React from 'react';
import * as consts from 'config/consts';

export type AccountType = typeof consts.AccountType[keyof typeof consts.AccountType];
export type BrokerType = typeof consts.BrokerType[keyof typeof consts.BrokerType];

const nisaTypes = [
  consts.AccountType.NISA,
  consts.AccountType.旧NISA,
  consts.AccountType['NISA（つみたて投資枠）'],
  consts.AccountType['NISA（成長投資枠）'],
] as number[];
export const isNisaTypes = (type: number) => {
  return nisaTypes.includes(type);
};

export const accountTypeToColors = (
  accountType: AccountType
): { foregroundColor: string; backgroundColor: string } => {
  switch (accountType) {
    case consts.AccountType.NISA:
    case consts.AccountType.旧NISA:
    case consts.AccountType['NISA（つみたて投資枠）']:
    case consts.AccountType['NISA（成長投資枠）']:
      return { backgroundColor: '#FEE2E2', foregroundColor: '#DC2626' };
    case consts.AccountType.一般:
      return { backgroundColor: '#E0F2FE', foregroundColor: '#0284C7' };
    case consts.AccountType.特定:
      return { backgroundColor: '#E2E8F0', foregroundColor: '#64748B' };
    case consts.AccountType.iDeCo:
    case consts.AccountType.企業型:
      return { backgroundColor: '#E4FFD7', foregroundColor: '#349C03' };
    case consts.AccountType.その他:
      return { backgroundColor: '', foregroundColor: '' };
  }
};

export const accountTypeToString = (accountType: AccountType): string => {
  switch (accountType) {
    case consts.AccountType.一般:
      return '一般';
    case consts.AccountType.特定:
      return '特定';
    case consts.AccountType.NISA:
    case consts.AccountType.旧NISA:
      return 'NISA';
    case consts.AccountType['NISA（つみたて投資枠）']:
      return 'NISA積立';
    case consts.AccountType['NISA（成長投資枠）']:
      return 'NISA成長';
    case consts.AccountType.企業型:
    case consts.AccountType.iDeCo:
      return '確定拠出年金';
    case consts.AccountType.その他:
      return 'その他';
  }
};

// MEMO: accountTypeが9(その他)の場合はラベルを表示させない。
export const AccountTypeLabel = ({
  accountType,
  brokerType,
  className,
}: {
  accountType: AccountType;
  brokerType?: BrokerType;
  className?: string;
}): React.ReactElement => {
  const isDefinedContributionPlan =
    (accountType === consts.AccountType.iDeCo ||
      accountType === consts.AccountType.企業型) &&
    brokerType !== undefined &&
    brokerType === consts.BrokerType.確定拠出年金;

  const str = isDefinedContributionPlan
    ? '確定拠出年金'
    : accountTypeToString(accountType);
  const {
    backgroundColor: backgroundColor_,
    foregroundColor,
  } = accountTypeToColors(accountType);
  const color = isDefinedContributionPlan ? '#349C03' : foregroundColor;
  const backgroundColor = isDefinedContributionPlan
    ? '#E4FFD7'
    : backgroundColor_;

  return (
    <>
      {accountType !== consts.AccountType.その他 && (
        <div
          style={{
            backgroundColor: backgroundColor,
            color: color,
            width: 'min-content',
          }}
          className={`rounded-full w-12 h-4 px-3 whitespace-no-wrap text-1.5xs items-center text-center flex flex-row justify-center ${
            className ? className : ''
          }`}>
          {str}
        </div>
      )}
    </>
  );
};
